import React, { useState, useContext } from 'react';
import { Outlet } from 'react-router-dom';
import Sidebar from './Sidebar';
import Header from './Header';
import NotificationOffcanvas from './NotificationOffcanvas';
import AuthContext from '../contexts/AuthContext';
import './Layout.css';

const Layout = () => {
    const { user } = useContext(AuthContext);
    const [isSidebarOpen, setIsSidebarOpen] = useState(false);

    const toggleSidebar = () => {
        setIsSidebarOpen(!isSidebarOpen);
    };

    return (
        <div className="app-layout">
            {user && <Sidebar isOpen={isSidebarOpen} toggleSidebar={toggleSidebar} />}

            <div className={`main-wrapper ${user ? 'with-sidebar' : ''}`}>
                <Header toggleSidebar={toggleSidebar} />
                <main className="main-content">
                    <Outlet />
                </main>
            </div>

            {/* Overlay for mobile sidebar */}
            {isSidebarOpen && (
                <div className="sidebar-overlay" onClick={() => setIsSidebarOpen(false)}></div>
            )}

            {/* In-App Notification Center */}
            {user && <NotificationOffcanvas />}
        </div>
    );
};

export default Layout;
